import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVExpansionPanel,
  EVExpansionPanelDetails,
  EVExpansionPanelSummary,
  EVGrid,
  EVExpandMore,
  EVTypography,
} from 'lib/components';
import NewBadge from 'commonComponents/newBadge';
import ProductStyles from './ProductStyles';

function ProductListExpansionPanel(props) {
  const {
    name, productList, icon, getSelectedProductsSubHeader,
  } = props;
  const classes = ProductStyles();

  return (
    <EVExpansionPanel classes={{ root: classes.productCategory, rounded: classes.productCategory, expanded: classes.productCategory }}>
      <EVExpansionPanelSummary
        expandIcon={<EVExpandMore />}
        aria-controls="panel1a-content"
        classes={{ root: classes.header, content: classes.header, expanded: classes.header }}
      >
        <EVGrid container spacing={0} alignItems="center" justifyContent="flex-start">
          <EVGrid className={classes.categoryImage} item>
            {/* <img src={icon} alt="propertyTypeIcon" width="60px" height="47px" /> */}
            {/* <Icon className={classes.iconStyle} /> */}
            {icon }
          </EVGrid>
          <EVGrid item>
            <EVTypography className={classes.header}>
              {name}
            </EVTypography>
          </EVGrid>
          <EVGrid item>
            <NewBadge />
          </EVGrid>
          {getSelectedProductsSubHeader()}
        </EVGrid>
      </EVExpansionPanelSummary>
      <EVExpansionPanelDetails className={classes.productContainer}>
        <EVGrid container>
          {productList()}
        </EVGrid>
      </EVExpansionPanelDetails>
    </EVExpansionPanel>
  );
}

ProductListExpansionPanel.propTypes = {
  name: PropTypes.string.isRequired,
  productList: PropTypes.func.isRequired,
  icon: PropTypes.element.isRequired,
  getSelectedProductsSubHeader: PropTypes.func.isRequired,
};
export default ProductListExpansionPanel;
